import { render, staticRenderFns } from "./UniversitySelectionField.vue?vue&type=template&id=41872a8f&scoped=true"
import script from "./UniversitySelectionField.vue?vue&type=script&lang=js"
export * from "./UniversitySelectionField.vue?vue&type=script&lang=js"
import style0 from "./UniversitySelectionField.vue?vue&type=style&index=0&id=41872a8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41872a8f",
  null
  
)

export default component.exports